import React from 'react';
import PropTypes from 'prop-types';

export default function Cell({
    className,
    verticalHeader,
    last,
    border,
    alignLeft,
    darkBg,
    isContent,
    divided,
    bottomBorder,
    children,
}) {
    const classNames = ['grid-cell'];
    if (className) {
        classNames.push(className);
    }

    if (verticalHeader) {
        classNames.push('grid-vertical-header');
    }

    if (last) {
        classNames.push('last');
    }

    if (alignLeft) {
        classNames.push('align-left');
    }

    if (darkBg) {
        classNames.push('dark-bg');
    }

    if (border) {
        classNames.push('border');
    }

    if (isContent) {
        classNames.push('content');
    }

    if (divided) {
        classNames.push('divided');
    }

    if (bottomBorder) {
        classNames.push('bottom-border');
    }

    return <div className={classNames.join(' ')}>{children}</div>;
}

Cell.propTypes = {
    sectionName: PropTypes.string.isRequired,
    className: PropTypes.string,
    verticalHeader: PropTypes.string,
    last: PropTypes.string,
    border: PropTypes.string,
    alignLeft: PropTypes.string,
    darkBg: PropTypes.string,
    isContent: PropTypes.string,
    divided: PropTypes.string,
    bottomBorder: PropTypes.string,
    children: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/components/ChannelCapabilitiesGrid/Cell.js